var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row align-items-center line-bar-chart" }, [
    _c("canvas", { staticClass: "chart-area", attrs: { id: _vm._uid } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }